/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type StarredCollectionForSidebarFragment = {
  readonly __typename: "Collection";
  readonly id: c.CollectionId;
  readonly name: string;
  readonly emoji: string | null;
};

export type GetStarredCollectionsForSidebarQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetStarredCollectionsForSidebarQuery = {
  readonly __typename: "Query";
  readonly collections: {
    readonly __typename: "CollectionsConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasPreviousPage: boolean;
      readonly hasNextPage: boolean;
      readonly startCursor: c.Cursor | null;
      readonly endCursor: c.Cursor | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "CollectionsEdge";
      readonly node: {
        readonly __typename: "Collection";
        readonly id: c.CollectionId;
        readonly name: string;
        readonly emoji: string | null;
      };
    }>;
  };
};

export const StarredCollectionForSidebarFragmentDoc = /*#__PURE__*/ gql`
  fragment StarredCollectionForSidebar on Collection {
    id
    name
    emoji
  }
`;
export const GetStarredCollectionsForSidebarDocument = /*#__PURE__*/ gql`
  query GetStarredCollectionsForSidebar {
    collections(ownershipLevel: ALL, onlyStarred: true, first: 30) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          ...StarredCollectionForSidebar
        }
      }
    }
  }
  ${StarredCollectionForSidebarFragmentDoc}
`;

/**
 * __useGetStarredCollectionsForSidebarQuery__
 *
 * To run a query within a React component, call `useGetStarredCollectionsForSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStarredCollectionsForSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStarredCollectionsForSidebarQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStarredCollectionsForSidebarQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetStarredCollectionsForSidebarQuery,
    GetStarredCollectionsForSidebarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStarredCollectionsForSidebarQuery,
    GetStarredCollectionsForSidebarQueryVariables
  >(GetStarredCollectionsForSidebarDocument, options);
}
export function useGetStarredCollectionsForSidebarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStarredCollectionsForSidebarQuery,
    GetStarredCollectionsForSidebarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStarredCollectionsForSidebarQuery,
    GetStarredCollectionsForSidebarQueryVariables
  >(GetStarredCollectionsForSidebarDocument, options);
}
export function useGetStarredCollectionsForSidebarSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetStarredCollectionsForSidebarQuery,
    GetStarredCollectionsForSidebarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetStarredCollectionsForSidebarQuery,
    GetStarredCollectionsForSidebarQueryVariables
  >(GetStarredCollectionsForSidebarDocument, options);
}
export type GetStarredCollectionsForSidebarQueryHookResult = ReturnType<
  typeof useGetStarredCollectionsForSidebarQuery
>;
export type GetStarredCollectionsForSidebarLazyQueryHookResult = ReturnType<
  typeof useGetStarredCollectionsForSidebarLazyQuery
>;
export type GetStarredCollectionsForSidebarSuspenseQueryHookResult = ReturnType<
  typeof useGetStarredCollectionsForSidebarSuspenseQuery
>;
export type GetStarredCollectionsForSidebarQueryResult = Apollo.QueryResult<
  GetStarredCollectionsForSidebarQuery,
  GetStarredCollectionsForSidebarQueryVariables
>;
